$mol_button $mol_view
	enabled true
	click? null
	event_click? null
	status? /
	event *
		^
		click? <=> activate? <=> event_activate? null
		dblclick? <=> clicks? null
		keydown? <=> key_press? <=> event_key_press? null
	attr *
		^
		disabled <= disabled false
		role \button
		tabindex <= tab_index 0
		title <= hint_safe <= hint \
	sub /$mol_view_content
		<= title
	Speck $mol_speck
		value <= error \
